import {
  dictionariesList,
  adminDictionariesList,
} from "../../pages/Dictionary/Dictionary";

// Map a BE entity SimpleName (the type/owner-type carried on audit-history
// rows) to its FE display label (Czech). Backend sends the raw simple class name,
// so we need to map it to something user-friendly.

const DICTIONARY_LABELS = (() => {
  const out = {};
  [...dictionariesList, ...adminDictionariesList].forEach((d) => {
    if (d && d.entityName && d.h1) out[d.entityName] = d.h1;
  });
  return out;
})();

const CORE_ENTITY_LABELS = {
  Official: "Funkcionář",
  OfficialWorkingPosition: "Pracovní pozice",
  OfficialEsmEntry: "Evidence skutečných majitelů",
  OfficialSettings: "Nastavení",
  InternalUser: "Interní uživatel",
  Ovm: "Podpůrný orgán",
  LegitimateAuthority: "Oprávněný orgán",
  FinancialInstitution: "Finanční instituce",
  PublicUser: "Veřejný uživatel",
  EsmSystem: "ESM systém",
  Statement: "Oznámení",
  Initiative: "Podnět",
  Request: "Žádost",
  Address: "Adresa",
  Person: "Osoba",
  LegalPerson: "Právnická osoba",
  Country: "Země",
  Municipality: "Obec",
  Cadastre: "Katastr",
  AssociatesMethod: "Způsob spolupráce",
  Help: "Nápověda",
};

export const ENTITY_LABELS = {
  ...DICTIONARY_LABELS,
  ...CORE_ENTITY_LABELS,
};

/** BE simple class name → Czech display label. Falls back to the input
 *  when the type is unknown (so the grid still shows something, not blank). */
export const entityLabel = (simpleName) =>
  (simpleName && ENTITY_LABELS[simpleName]) || simpleName || "";

export const ENTITY_TYPE_ITEMS = Object.entries(ENTITY_LABELS)
  .map(([id, label]) => ({ id, label }))
  .sort((a, b) => a.label.localeCompare(b.label, "cs"));

export const OFFICIAL_HISTORY_ENTITIES = ["Official", "Statement"];
export const OVM_HISTORY_ENTITIES = ["Ovm", "Official"];
export const LEGITIMATE_HISTORY_ENTITIES = ["LegitimateAuthority", "Official"];
export const FINANCIAL_HISTORY_ENTITIES = ["FinancialInstitution"];
export const SPRAVCE_HISTORY_ENTITIES = [
  "Official",
  "Ovm",
  "LegitimateAuthority",
  "FinancialInstitution",
  "InternalUser",
  "Initiative",
  "Request",
  "Statement",
  "Help",
];
export const INITIATIVE_HISTORY_ENTITIES = ["Initiative"];
export const REQUEST_HISTORY_ENTITIES = ["Request"];

export const entityTypeItemsFor = (allowedIds) =>
  allowedIds && allowedIds.length
    ? ENTITY_TYPE_ITEMS.filter((it) => allowedIds.includes(it.id))
    : ENTITY_TYPE_ITEMS;

export const OFFICIAL_HISTORY_ACTIONS = [
  "CREATE",
  "UPDATE",
  "DELETE",
  "NOTE",
  "LOGIN",
  "LOGOUT",
  "PASSWORD_CHANGED",
  "STATEMENT_CHECKED",
  "STATEMENT_SUBMITTED",
  "STATEMENT_INCOMPLETE",
  "CREATE_STATEMENT",
  "OPEN_TEMPLATE_STATEMENT",
  "OPEN_NEW_STATEMENT",
  "APPEAL_SENT",
];
export const OVM_HISTORY_ACTIONS = [
  "CREATE",
  "UPDATE",
  "DELETE",
  "LOGIN",
  "LOGOUT",
  "PASSWORD_CHANGED",
];
export const LEGITIMATE_HISTORY_ACTIONS = [
  "CREATE",
  "UPDATE",
  "DELETE",
  "LOGIN",
  "LOGOUT",
  "PASSWORD_CHANGED",
];
export const FINANCIAL_HISTORY_ACTIONS = [
  "CREATE",
  "UPDATE",
  "DELETE",
  "LOGIN",
  "LOGOUT",
  "PASSWORD_CHANGED",
];
export const INITIATIVE_HISTORY_ACTIONS = [
  "CREATE",
  "UPDATE",
  "DELETE",
  "INITIATIVE_ACCEPTED",
  "INITIATIVE_REPLIED",
  "INITIATIVE_REJECTED",
  "INITIATIVE_FORWARDED",
];
export const REQUEST_HISTORY_ACTIONS = [
  "CREATE",
  "UPDATE",
  "DELETE",
  "REQUEST_ACCEPTED",
  "REQUEST_REJECTED",
];
export const DICTIONARY_HISTORY_ACTIONS = ["CREATE", "UPDATE", "DELETE"];

export const actionsFor = (allowedIds, actions) =>
  allowedIds && allowedIds.length
    ? actions.filter((a) => allowedIds.includes(a.id))
    : actions;
